import MenuConst from "../MenuConst";

export class GoodMapMenu extends MenuConst {
    static readonly NONE:number     = MenuConst.NONE;
    static readonly ADD:number      = MenuConst.GOOD;
    static readonly MAIN:number     = MenuConst.GOOD + 1;

    static arr = (():string[] => {
        let arr = [];

        arr[GoodMapMenu.NONE] = '';
        arr[GoodMapMenu.ADD]  = 'Dodaj dobro';
        arr[GoodMapMenu.MAIN] = '';// 'Zestawienie';

        return arr;
    })();

    static admin = (():boolean[] => {
        let admin = [];

        admin[GoodMapMenu.NONE] = true;
        admin[GoodMapMenu.ADD]  = false;
        admin[GoodMapMenu.MAIN] = true;

        return admin;
    })();
}

